/* pa-slideshow-pause.js — WCAG 2.2.2 (Pause, Stop, Hide)
 * The homepage Flickity slideshow auto-advances with no way to stop it. This
 * injects an accessible Pause/Play toggle into the slideshow and wires it to
 * Flickity's player. Also honors prefers-reduced-motion by starting paused.
 * Self-contained; no markup changes needed in the section.
 */
(function () {
  var PAUSE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';

  function build(el, flkty) {
    if (!el || !flkty || !flkty.player) return false;
    if (el.querySelector('.pa-slideshow-pause')) return true;

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pa-slideshow-pause';
    btn.style.cssText = [
      'position:absolute', 'bottom:16px', 'right:16px', 'z-index:20',
      'width:44px', 'height:44px', 'display:inline-flex',
      'align-items:center', 'justify-content:center',
      'border:1px solid rgba(255,255,255,0.7)', 'border-radius:50%',
      'background:rgba(0,0,0,0.55)', 'color:#ffffff', 'cursor:pointer',
      'padding:0', 'line-height:0'
    ].join(';');

    var playing = !reduce;

    function render() {
      btn.innerHTML = playing ? PAUSE : PLAY;
      btn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      btn.setAttribute('aria-pressed', String(!playing));
    }

    if (reduce) {
      try { flkty.pausePlayer(); } catch (e) {}
    }

    btn.addEventListener('click', function () {
      try {
        if (playing) { flkty.pausePlayer(); } else { flkty.unpausePlayer(); }
      } catch (e) {}
      playing = !playing;
      render();
    });

    render();
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.appendChild(btn);
    return true;
  }

  function init() {
    if (!window.Flickity) return false;
    var el = document.querySelector('.js-homepage-slideshow.flickity-enabled, .homepage-slideshow.flickity-enabled');
    if (!el) return false;
    var flkty = window.Flickity.data(el);
    return build(el, flkty);
  }

  var tries = 0;
  var iv = setInterval(function () {
    if (init() || ++tries > 60) clearInterval(iv);
  }, 250);
  document.addEventListener('DOMContentLoaded', init);
})();
